import { Spacer } from "../atoms/Atoms"
import React from "react"
import styled from "styled-components"
import { IlloWhereAreYouMap } from "../atoms/Illustrations"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { BodySmall } from "../atoms/Bodies"
import { Button } from "../atoms/buttons/Button"
import { H2 } from "@carrotfertility/carotene"

const HeroText = styled.span`
  font-size: 17px;
  line-height: 1.5em;
`

const JourneyHero = () => (
  <div className="flex flex-auto flex-row">
    <RoundedRectangle padding="pa0" backgroundColor="warm-gray">
      <div className="flex flex-row-reverse flex-wrap justify-end">
        <div className="flex w-50 items-center">
          <div className="pa35">
            <IlloWhereAreYouMap className="w-100 h-auto" />
          </div>
        </div>
        <div className="w-50 flex flex-column flex-grow-1 min-w250px pa35">
          <H2>Where are you on your journey?</H2>
          <Spacer height={1} />
          <BodySmall font="publico-text" color="black-80">
            <HeroText>
              Answer a few simple questions to help us provide you with a more personalized Carrot experience.
            </HeroText>
          </BodySmall>
          <Spacer height={1.5} />
          <Button outline to="/fle/journey/intro?isEntryPoint=true">
            Let&apos;s start
          </Button>
        </div>
      </div>
    </RoundedRectangle>
  </div>
)

export default JourneyHero
